import Icon, { IconName } from '@/components/Icons'
import { Wrapper } from '@/components/InfoBadge.styles'
import { BannerContent } from '@/components/GalleryProductLayout.styles'
import { Body, Spacing } from '@big-red-group/storefront-common-ui'

type InfoBadgeProps = {
  heading: string
  subText: string
  iconName: IconName
  backgroundColor: string
  borderColor: string
  textColor: string
}

const InfoBadge: React.FC<InfoBadgeProps> = ({
  heading,
  subText,
  iconName,
  backgroundColor,
  borderColor,
  textColor,
}) => {
  return (
    <Wrapper $backgroundColor={backgroundColor} $color={textColor} $borderColor={borderColor}>
      <Icon name={iconName} />
      <BannerContent>
        <Body size="S" weight="bold" as="span">
          {heading}
        </Body>
        <Spacing size="XXXS" />
        <Body size="XS" weight="regular" as="span">
          {subText}
        </Body>
      </BannerContent>
    </Wrapper>
  )
}

export default InfoBadge
